<div class="box" role="status">
  <div class="has-text-centered mb-5">
    <span class="icon is-large has-text-success">
      <i class="fa-solid fa-circle-check fa-3x"></i>
    </span>
  </div>

  <h2 class="title is-4 has-text-centered">{{ 'completion.successMessage' | localize }}</h2>

  <div class="content">
    <dl class="submission-summary">
      <dt>{{ 'completion.label.submissionId' | localize }}</dt>
      <dd>{{ submissionId }}</dd>

      <dt>{{ 'completion.label.formTitle' | localize }}</dt>
      <dd>{{ formTitle }}</dd>

      <dt>{{ 'completion.label.submittedAt' | localize }}</dt>
      <dd>{{ submittedAt | date:'medium' }}</dd>
    </dl>
  </div>

  <div class="field mt-5">
    <div class="control has-text-centered">
      <button class="button is-primary"
              (click)="onSubmitAnother()">
        {{ 'completion.button.submitAnother' | localize }}
      </button>
    </div>
  </div>
</div>
